import React from "react";
import "../styles/Accessibility.css";
import { Link } from "react-router-dom";

const PartnerPlacesAgreement = () => {
  return (
    <div className="legal-wrapper">
      <main className="legal-main">
        <h1>Partner Places Agreement</h1>
        <p className="effective-date">Effective: September 10, 2019</p>

        <h3>1. Contractual Relationship</h3>
        <p>
          This Agreement ("Agreement") is made and entered into by and between the
          partner place ("PARTNER PLACE / RESTAURANT"), the undersigned contractor
          ("INDEPENDENT PARTNER"), an independent partner engaged in the business
          of performing the transportation / customer acquisition services
          described by this Agreement, and BERYMO, Inc. ("BERYMO" or/and "BERYMO
          PLACES"). This Agreement will become effective on the date it is
          accepted regardless of whether you are eligible to, or ever do, perform
          any Contracted Services.
        </p>
        <p>
          <strong>
            BEFORE YOU PARTICIPATE IN THE PROGRAM(S) OPERATED BY BERYMO, INC.
            (“BERYMO”) THAT ARE COVERED BY THESE BERYMO PARTNER PLACES TERMS OF USE
            (“PARTNER PLACES TERMS”), PLEASE READ THESE TERMS CAREFULLY. BY
            EXECUTING THE PARTNERSHIP PROGRAM WITH BERYMO, YOU OR THE ENTITY THAT
            YOU REPRESENT AGREE ON BEHALF OF ALL PARTICIPATING RESTAURANT
            LOCATIONS TO BE BOUND BY THESE TERMS TO THE EXCLUSION OF ALL OTHER
            TERMS.
          </strong>
        </p>

        <h3>2. Berymo Core Responsibilities</h3>
        <p>Berymo will:</p>
        <ul>
          <li>
            Display Berymo Places logo; a listing of the partner places that are
            listed on the "Berymo Places Website" or later added by an exchange of
            emails.
          </li>
          <li>
            Accept transportation requests for Partner Places through Berymo's
            proprietary system (the “Berymo Web Platform”) from Berymo Riders
            (“Customers”);
          </li>
          <li>Forward each transportation request to the relevant Place; and</li>
          <li>
            Forward each transportation request to a third-party delivery
            contractor (“Berymo Driver”), so that the Driver can pick up the rider
            ("customer") to transport to the Place. If Berymo determines that the
            Place could subject Berymo to undue regulatory risk or other liability,
            then Berymo may remove such Place from the Berymo Platform.
          </li>
        </ul>

        <h3>3. Partner Place Responsibilities</h3>
        <p>Partner Place will:</p>
        <ul>
          <li>
            Provide Berymo Places with some of the Place's in-store menu, and
            notify Berymo Places of any updates made to the Place’s in-store menu
            within 2 business days from the date of change;
          </li>
          <li>
            Confirm all ride request from Berymo Places in a prompt and timely
            manner by being online;
          </li>
          <li>
            Prepare the designated seating for each transportation request for the
            rider ("customer");
          </li>
          <li>
            Notify Berymo Places of any changes to the pricing, availability,
            description, or other characteristics of the Place Menu;
          </li>
          <li>
            Notify Berymo Places of any changes to Place’s hours of operations on
            federal holidays, and notify Berymo Places if a Place closes earlier
            than Place’s standard hours of operation or plans to close earlier than
            Place’s standard hours of operation;
          </li>
          <li>
            Notify all Place staff members of the relationship with Berymo Places
            immediately upon execution of this Agreement; and Provide the Berymo
            code.
          </li>
          <li>
            Pay a service fee per customer who has been checked-in at the place;
          </li>
          <li>
            Schedule Payments on every Monday (if your service fee exceeds $100
            daily, you will be charged immediately instead on Monday due to
            payments we make to our drivers.)
          </li>
        </ul>

        <h3>4. Request Cancellations and Non Checked-in Customer</h3>
        <p>
          In the event of the trip request cancellation by the customer ("rider")
          and/or non checked-in customer, Berymo Places will pay the full amount to
          the place which has been requested by the customer.
        </p>

        <h3>5. Use of Place Trademark and Content</h3>
        <p>
          For so long as the Place Agreement remains in effect, Place grants to
          Berymo Places a royalty-free, non-exclusive, limited, revocable,
          non-transferable right and license to use the content, including without
          limitation, menus, photographs, trademarks, and logos provided by Place
          to Berymo Places to use in providing services to the Place.
        </p>

        <h3>6. Confidential Information</h3>
        <p>
          The term “Confidential Information” shall mean any confidential or
          proprietary business, technical or financial information or materials of
          a party (“Disclosing Party”) provided to the other party (“Receiving
          Party”) in connection with this Agreement, whether orally or in physical
          form, and shall include the terms of this Agreement.
        </p>

        <h3>7. Data Privacy</h3>
        <p>
          Place agrees not to access, collect, store, retain, transfer, use or
          otherwise process in any manner Berymo Data, including without limitation
          Personal Information, except as required to perform under this Agreement.
          Place shall keep Berymo Places Data secure from unauthorized access and
          maintain the accuracy and integrity of Berymo Places Data in Place’s
          custody or control by using appropriate organizational, physical and
          technical safeguards. If a Place becomes aware of any unauthorized access
          to Berymo Places Data, Place will immediately notify Berymo Places,
          consult and cooperate with investigations and potentially require
          notices, and provide any information reasonably requested by Berymo
          Places.
        </p>

        <h3>8. Termination</h3>
        <p>
          Place may terminate this agreement for any reason at any time upon 10
          days prior written notice. Berymo Places may terminate this agreement for
          any reason at any time upon written notice. Email shall suffice for
          written notice. Neither Place nor Berymo Places will be required to pay
          any fee in connection with a termination by either party, or be liable to
          the other as a result of termination of this Agreement for any damages,
          for the loss of goodwill, prospective profits or anticipated income, or
          on account of any expenditures, investments, leases or commitments made
          by either Place or Berymo Places.
        </p>

        <h3>9. Modifications</h3>
        <p>
          Berymo Places reserves the right, at its sole discretion, to change,
          suspend, or discontinue the Platform (including without limitation, the
          availability of any feature or content) at any time. Berymo Places also
          may revise these Terms from time to time. We will notify Partner Places
          of material revisions via a service notification or an email to the
          email associated with your account. By continuing to access or use the
          services after those revisions become effective, you agree to be bound by
          the revised Terms.
        </p>

        <h3>10. Representations and Warranties; Disclaimer</h3>
        <p>
          Each party represents and warrants that it has the full right, power,
          and authority to enter into and perform its obligations under this
          Agreement without breaching any obligation to any third party. Place
          represents and warrants that it will comply with all applicable laws and
          regulations in its performance of this Agreement, including without
          limitation:
        </p>
        <ul>
          <li>all applicable data protection and privacy laws;</li>
          <li>
            all applicable laws, rules, standards and regulations relating to
            licenses, health, food safety, and sanitation; and
          </li>
          <li>
            all applicable laws related to third party intellectual property and
            other proprietary rights.
          </li>
        </ul>
        <p>
          <strong>
            EXCEPT AS EXPRESSLY SET FORTH HEREIN, TO THE EXTENT PERMITTED BY
            APPLICABLE LAW, BERYMO HEREBY EXPRESSLY DISCLAIMS ALL WARRANTIES,
            EXPRESS, IMPLIED OR STATUTORY, REGARDING THE BERYMO PLATFORM, EQUIPMENT
            OR SERVICES.
          </strong>
        </p>
        <p>
          Place acknowledges that the operation of the Platform may from time to
          time encounter technical or other problems and may not necessarily
          continue uninterrupted or without technical or other errors and Berymo
          Places shall not be responsible for Place or others for any such
          interruptions, errors, or problems or an outright discontinuance of the
          Platform nor for any guarantee of results with respect to the Berymo
          Places services contemplated herein. Both Parties acknowledge that
          neither party has any expectation or has received any assurances for
          future business or that any investment by a party will be recovered or
          recouped or that such party will obtain any anticipated amount of profits
          by virtue of this Agreement.
        </p>

        <h3>11. General Provisions</h3>
        <p>
          Nothing in these Terms is to be construed as creating an agency,
          partnership, or joint venture relationship between Berymo Places and
          Place, and except as expressly set forth herein, each party shall be
          responsible for its own costs of performance hereunder. As set forth on
          the Place Agreement executed between Place and Berymo Places, these Terms
          form part of an Agreement between the parties, which supersedes all prior
          agreements and communications of the parties, oral or written, with
          respect to the subject matter hereof. Except as set forth herein, no
          amendment to, or waiver of, any provision of this Agreement will be valid
          unless in writing and signed by both parties. The waiver by any party of
          any breach or default will not constitute a waiver of any different or
          subsequent breach or default. This Agreement is governed by and
          interpreted in accordance with the laws of the State of California
          without regard to the conflicts of laws principles thereof. Place may not
          assign this Agreement in whole or in part without Berymo Place's prior
          written consent. Berymo Places may freely assign this Agreement. This
          Agreement will be binding upon, and inure to the benefit of, the
          permitted successors and assigns of each party, but shall not confer any
          rights or remedies upon any other third party.
        </p>
      </main>
      <aside className="legal-sidebar">
        <ul>
          <li>
            <Link to="/Legal">Privacy Policy</Link>
          </li>
          <hr />
          <li>
            <Link to="/TermsofUse">Terms of Use</Link>
          </li>
          <hr />
          <li>
            <Link to="/Accessibility">Accessibility</Link>
          </li>
          <hr />
          <li>
            <Link to="/Independent">Independent Contractor Agreement</Link>
          </li>
          <hr />
          <li>
            <Link to="/PartnerPlacesAgreement" className="active">
              Partner Places Agreement
            </Link>
          </li>
          <hr />
        </ul>
      </aside>
    </div>
  );
};

export default PartnerPlacesAgreement;

